var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasSomethingToShow
    ? _c(
        "div",
        {
          class: [_vm.data.componentBaseClassName, _vm.data.componentClassName]
        },
        [
          _vm.regionsHtml.title
            ? _c("div", {
                class: _vm.data.titleClassName,
                domProps: { innerHTML: _vm._s(_vm.regionsHtml.title) }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.products.length
            ? _c(
                "div",
                { class: _vm.data.productsClassName },
                _vm._l(_vm.products, function(product, index) {
                  return _c(
                    "BaseLink",
                    {
                      key: _vm.data.productsClassName + "-product-" + index,
                      class: _vm.data.imageClassName,
                      attrs: { url: product.link }
                    },
                    [
                      _c("BaseImage", {
                        attrs: { src: product.image, alt: product.name },
                        on: {
                          load: function($event) {
                            return _vm.handleImageLoad(product, index)
                          },
                          "image-click": function($event) {
                            return _vm.emitAnalyticsData(product, index)
                          }
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            : _vm.sliderProducts.length
            ? _c("BaseProductSlider", {
                attrs: {
                  products: _vm.sliderProducts,
                  "wrap-items": _vm.data.layout === "grid",
                  "show-scrollbar": _vm.data.layout === "slider",
                  navigation:
                    _vm.isHome && _vm.data.layout === "slider"
                      ? _vm.data.navigation || "hover"
                      : null,
                  "hide-product-names": _vm.data.hideNames,
                  "hide-prices": _vm.data.hidePrices,
                  "hide-quick-shop": _vm.data.hideQuickShop,
                  "tile-context": _vm.homeRecommendedEinsteinProducts,
                  "is-recommendation-from-einstein":
                    _vm.isRecommendationFromEinstein,
                  "recommender-name": _vm.data.recommenderName
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }